/**
 * The single rule for what modifier rows leave hub.
 *
 * DESELECTED OPTIONS ARE DROPPED, NEVER SENT AT QUANTITY 0.
 *
 * `processItemsOrder` charges `price * (mod.quantity || 1)`, so a forwarded `0` is promoted
 * server-side to one charged portion — an add-on nobody ordered. This is not theoretical: the old hub
 * picker persisted unticked options at `quantity: 0`, so stored orders really do contain them
 * (`docs/decisions.md` records 34 rows on staging), and every path that rehydrates a stored order —
 * reorder, order edit — carries them back out again unless they are filtered here.
 *
 * `?? 1` inside the filter, not `|| 1`: a MISSING quantity legitimately means one portion for the line
 * and must survive, while an explicit `0` must not.
 *
 * `quantity` is the LINE TOTAL (picked x line quantity) and is passed through unscaled — the backend
 * multiplies nothing. See utils/lineModifierQuantities.ts.
 *
 * Used by every outbound path: the calculate/preview payload and createOrder in store/order.ts, and
 * prepareItemsForUpdate on the order-detail page. Previously each of those had its own mapping (or
 * none), which is how the create path ended up able to charge a deselected add-on while the update
 * path could not.
 */

type OutboundModifier = {
	modifier_group_id?: number | string
	modifier_id?: number | string
	group_id?: number | string
	id?: number | string
	quantity?: number
	[key: string]: unknown
}

export function outboundModifiers(modifiers: OutboundModifier[] | undefined | null) {
	return (modifiers || [])
		.filter((m) => (m.quantity ?? 1) > 0)
		.map((m) => ({
			modifier_group_id: m.modifier_group_id ?? m.group_id,
			modifier_id: m.modifier_id ?? m.id,
			quantity: m.quantity ?? 1,
		}))
}
